import React from 'react';
import AppLayout from '../../layout/app.layout';
import PAGE_TITLE_LIST from '../../config/page-title.config';
import ListCollection from '../../components/collection/list-collection.component';

const ContentCollectionView = () => {
  const pageTitle = PAGE_TITLE_LIST.CONTENT_COLLECTIONS;

  return (
    <AppLayout pageTitle={pageTitle}>
      <ListCollection />
    </AppLayout>
  );
};

export default ContentCollectionView;
